module.exports = __webpack_public_path__ + "static/media/logout.212a9e6f.svg";